"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const admin_1 = __importDefault(require("./admin"));
const ai_1 = __importDefault(require("./ai"));
const auth_1 = __importDefault(require("./auth"));
const billing_1 = __importDefault(require("./billing"));
const collection_1 = __importDefault(require("./collection"));
const configuration_1 = __importDefault(require("./configuration"));
const conversation_1 = __importDefault(require("./conversation"));
const course_1 = __importDefault(require("./course"));
const document_1 = __importDefault(require("./document"));
const email_1 = __importDefault(require("./email"));
const lernsets_1 = __importDefault(require("./lernsets"));
const mindItem_1 = __importDefault(require("./mindItem"));
const notification_1 = __importDefault(require("./notification"));
const product_1 = __importDefault(require("./product"));
const registration_1 = __importDefault(require("./registration"));
const school_1 = __importDefault(require("./school"));
const search_1 = __importDefault(require("./search"));
const text_1 = __importDefault(require("./text"));
const track_1 = __importDefault(require("./track"));
const user_1 = __importDefault(require("./user"));
exports.default = {
    admin: admin_1.default,
    ai: ai_1.default,
    auth: auth_1.default,
    billing: billing_1.default,
    collection: collection_1.default,
    configuration: configuration_1.default,
    course: course_1.default,
    document: document_1.default,
    email: email_1.default,
    lernsets: lernsets_1.default,
    mindItem: mindItem_1.default,
    notification: notification_1.default,
    product: product_1.default,
    registration: registration_1.default,
    school: school_1.default,
    search: search_1.default,
    text: text_1.default,
    track: track_1.default,
    user: user_1.default,
    conversation: conversation_1.default,
};
